import React, { useContext, useState, useEffect } from "react";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { StoreContext } from "../../../../../Store/Provider";
import "./shipmentDetails.css";
import SidebarData from "../SidebarData/SidebarData";
import {
  HOST_URL,
  shipment_enquiry_mail,
  default_whatsapp_no,
} from "../../../../../Config";
import axios from "axios";
import { getUserData } from "../../../../Common/Utility/Utils";
import CloseIcon from "@material-ui/icons/Close";
import MailIcon from "@material-ui/icons/Mail";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Bell from "../../../../SVG/Bell";
import DocumentSVG from "../../../../SVG/DocumentSVG";
import Line from "../../../../SVG/Line";
import LocateTrack from "../../../../SVG/LocateTrack";
import ShipmentDetailsIcon from "../../../../SVG/ShipmentDetailsIcon";
import Sea from "../../../../SVG/Sea";
import Plane from "../../../../SVG/Plane";
import RoadSVG from "../../../../SVG/RoadSVG.js";
import CourierSVG from "../../../../SVG/CourierSVG";
import RailSVG from "../../../../SVG/RailSVG";
import PlaceDot from "../../../../SVG/PlaceDot";
import MileStone from "../../../../SVG/MileStone";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { localStoragekey } from "../../../../Common/Utility/Utils";
import Whatsapp from "../../../../SVG/Whatsapp";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function ShipmentDetails(props) {
  const context = useContext(StoreContext);
  const { detailData, close } = props;
  const [detail, setDetail] = useState({
    data: {},
    loading: false,
    error: false,
  });
  const [milestoneData, setMilestoneData] = useState({
    data: [],
    loading: false,
    error: false,
  });
  const [notified, setNotified] = useState(false);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    setDetail({ ...detail, loading: true, data: {}, error: false });
    setMilestoneData({
      ...milestoneData,
      data: [],
      loading: true,
      error: false,
    });
    onShipmentDetail();
    getMileStoneData();
  }, [context.shipmentNo]);

  useEffect(() => {
    setNotified("");
    if (detail.data.Marked) {
      setNotified(detail.data.Marked);
    }
  }, [detail]);

  const getMileStoneData = async () => {
    const end_point = `${HOST_URL}api/v1/Shipment/MILESTONE`;
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };

    const params = {
      companyCode: userData.orgs,
      countryCode: "",
      transportmode: detailData.TransportMode,
      shipmentid: context.shipmentNo,
    };

    axios
      .post(end_point, params, {
        headers: header,
      })
      .then((res) => {
        console.log("res", res);
        if (res.data.Value) {
          if (res.data.Value) {
            setMilestoneData({
              ...milestoneData,
              data: res?.data?.Value ?? [],
              loading: false,
              error: false,
            });
          }
        }
      })
      .catch((err) => {
        setMilestoneData({
          ...milestoneData,
          data: [],
          loading: false,
          error: true,
        });
        console.log({ err });
      });
  };

  const onShipmentDetail = async () => {
    const end_point = `${HOST_URL}api/v1/Shipment/DETAIL`;
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };

    const params = {
      companyCode: userData.orgs,
      countryCode: "",
      shipmentid: context.shipmentNo,
    };
    axios
      .post(end_point, params, {
        headers: header,
      })
      .then((res) => {
        if (res.data.Value) {
          setDetail({ data: res.data.Value, loading: false, error: false });
          context.setShipmentdetails(res.data.Value);
        }
      })
      .catch((err) => {
        console.log({ err });
        setDetail({ data: {}, loading: false, error: true });
      });
  };

  const bookMarkShipment = async () => {
    setOpen(true);
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      UserName: userData.userName,
      UserSecret: userData.userSecret,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const params = new URLSearchParams();
    params.append("UserId", userData.userName);
    params.append("EntityId", detailData.ShipmentId);
    params.append("DeviceId", "");
    const END_POINT = `https://dashboard.mts-logistics.com/MTSConnectAPIServices/api/v1/MarkedData/Shipment`;
    axios
      .post(END_POINT, params, {
        headers: header,
      })
      .then((res) => {
        setOpen(false);
        console.log("notify", res.data.IsMarked);
        setNotified(res.data.IsMarked);
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const notifymark = async () => {
    setOpen(true);
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    const params = {
      Userid: userData.EMail,
      DeviceId: "W",
      ShipmentId: detailData?.ShipmentId ?? "",
      Timestamp: moment().toISOString(),
      Marked: !notified,
    };
    axios
      .post(`${HOST_URL}api/v1/Shipment/MarkShipment`, params, {
        headers: header,
      })
      .then((res) => {
        if (res.data?.Success) {
          setNotified(!notified);
          NotificationManager.success(res.data?.ResultMessage, "", 3000);
        } else {
          NotificationManager.error(res.data?.ResultMessage, "", 3000);
        }
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const sendMail = async () => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    let body = `Hello, %0A%0ATeam SFL, %0A%0ACould you please send more details about my shipment? %0A%0AShipment Number: ${
      detailData?.ShipmentId ?? ""
    } %0AHouse BL Number: ${detailData?.HouseBL ?? ""} %0ATransport Mode: ${
      detailData?.TransportMode ?? ""
    } %0A%0AThank you! %0A${userData?.userFullName ?? ""}%0A%0A`;
    window.location.href = `mailto:${shipment_enquiry_mail}?subject=Shipment ID - ${
      detailData?.ShipmentId ?? ""
    }&body=${body}`;
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  if (context.sidebarContent !== "shipmentDetails") {
    return <SidebarData detail={detail} milestone={milestoneData} />;
  }

  const JobOperatorNumber =
    context?.shipmentdetails?.JobOperatorNo !== ""
      ? context?.shipmentdetails?.JobOperatorNo
      : default_whatsapp_no;

  return (
    <div className="shipmentDetails">
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress />
      </Backdrop>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <h6>
        Shipment Details{" "}
        <span>
          <CloseIcon
            onClick={() => {
              close();
            }}
          />
        </span>
      </h6>
      <div className="shipmentDetailsDiv">
        <div className="shipmentDetailsDivHeading">
          <p>
            <span>{detailData?.ShipmentId}</span>
          </p>
          <div className="iconsDiv">
            <Bell
              notified={notified}
              onClickBell={notifymark}
              colorCode={"rgba(var(--text-heading-light))"}
              classSidebar={"classSidebar TourtenthStep tranformAnimation"}
            />
            <span
              className="pointer ToureleventhStep tranformAnimation"
              onClick={sendMail}
            >
              <MailIcon />
            </span>
            {/* <LocateTrack
            colorCode={"rgba(var(--text-heading-light))"}
            onClickLocate={() => context.setSidebarContent("track")}
            classSidebar={
              "pointer classSidebar TourtwelvethStep tranformAnimation"
            }
          /> */}
            <span className="tranformAnimation">
              <a
                href={`https://web.whatsapp.com/send?phone=${JobOperatorNumber}`}
                target="_blank"
              >
                <Whatsapp
                  title="Message"
                  className="pointer "
                  colorCode={"rgba(var(--text-heading-light))"}
                />
              </a>
            </span>
          </div>
        </div>
        <div className="shipmentRoutePlace">
          <div className="shptimelinebody">
            <span>{detailData.OriginPort} </span>
            <div className="shptimelinecontainer">
              <span>
                {detailData.TransportMode === "SEA" ? (
                  <Sea
                    colorCode={"rgba(var(--text-heading-light))"}
                    seaClass={"shptimelinemode"}
                  />
                ) : detailData.TransportMode === "ROA" ? (
                  <RoadSVG
                    colorCode={"rgba(var(--text-heading-light))"}
                    planeClass={"shptimelinemode"}
                  />
                ) : detailData.TransportMode === "COU" ? (
                  <CourierSVG
                    colorCode={"rgba(var(--text-heading-light))"}
                    planeClass={"shptimelinemode"}
                  />
                ) : detailData.TransportMode === "RAI" ? (
                  <RailSVG
                    colorCode={"rgba(var(--text-heading-light))"}
                    planeClass={"shptimelinemode"}
                  />
                ) : detailData.TransportMode === "AIR" ? (
                  <Plane
                    colorCode={"rgba(var(--text-heading-light))"}
                    planeClass={"shptimelinemode"}
                  />
                ) : null}
              </span>
              <span>
                <PlaceDot colorCode={"rgba(var(--text-heading-light))"} />
              </span>
              <Line
                colorCode={"rgba(var(--text-heading-light))"}
                classDotted={"dottedline"}
              />
            </div>
            <span>{detailData?.DestinationPort} </span>
          </div>
          <p className="orgDestName">
            <span title={detailData?.OriginPortName}>
              {detailData?.OriginPortName}
            </span>
            <span title={detailData?.DestinationPortName}>
              {detailData?.DestinationPortName}
            </span>
          </p>
        </div>
        <div className="shipmentRouteDate">
          <p className="orgDestName">
            <span>ATD</span>
            <span>ATA</span>
          </p>
          <p className="orgDestName orgDestDate">
            <span>
              {detailData?.ATD
                ? detailData?.ATD.split(" ")[0] === "01/01/1900" ||
                  detailData?.ATD === "1/1/1900" ||
                  detailData?.ATD.split(" ")[0] === "01/01/0001"
                  ? "N/A"
                  : detailData?.ATD.split(" ")[0]
                : ""}
            </span>
            <span>
              {detailData?.ATA
                ? detailData?.ATA.split(" ")[0] === "01/01/1900" ||
                  detailData?.ATA === "1/1/1900" ||
                  detailData?.ATA.split(" ")[0] === "01/01/0001"
                  ? "N/A"
                  : detailData?.ATA.split(" ")[0]
                : ""}
            </span>
          </p>
        </div>
      </div>
      <div
        className="shipmentDetailsTabDiv TourfifteenthStep"
        onClick={() => {
          context.setSidebarContent("shipmentDataDetails");
        }}
      >
        <div className="shipmentDetailsTabDivIconTitle">
          <div>
            <ShipmentDetailsIcon
              colorCode={"rgba(var(--text-heading-light))"}
              classSidebar={"classSidebar"}
            />
          </div>
          <span>Details of Shipments</span>
        </div>
        <ArrowForwardIosIcon />
      </div>
      <div
        className="shipmentDetailsTabDiv"
        onClick={() => {
          context.setSidebarContent("track");
        }}
      >
        <div className="shipmentDetailsTabDivIconTitle">
          <div>
            <LocateTrack
              colorCode={"rgba(var(--text-heading-light))"}
              onClickLocate={() => {}}
              classSidebar={"classSidebar"}
            />
          </div>
          <span>Track on Map</span>
        </div>
        <ArrowForwardIosIcon />
      </div>
      <div
        className="shipmentDetailsTabDiv TourfourteenthStep"
        onClick={() => {
          context.setSidebarContent("milestones");
        }}
      >
        <div className="shipmentDetailsTabDivIconTitle ">
          <div>
            <MileStone
              colorCode={"rgba(var(--text-heading-light))"}
              onClickLocate={() => {}}
              classSidebar={"classSidebar "}
            />
          </div>
          <span>Milestones</span>
        </div>
        <ArrowForwardIosIcon />
      </div>
      <div
        className="shipmentDetailsTabDiv ToursixteenthStep"
        onClick={() => {
          context.setSidebarContent("Documents");
        }}
      >
        <div className="shipmentDetailsTabDivIconTitle">
          <div>
            <DocumentSVG
              colorCode={"rgba(var(--text-heading-light))"}
              classSidebar={"classSidebar"}
            />
          </div>
          <span>Documents</span>
        </div>
        <ArrowForwardIosIcon />
      </div>
    </div>
  );
}

export default ShipmentDetails;
